import dayjs from 'dayjs'

/**
 * Converts a date (either as a Date object or a string representation of a date) to a string in the format YYYY-MM-DD
 *
 * TODO: refactor out `.toISOString().split('T')[0]` references to use this method
 * */
export function getFormattedInstallationDateString(
  installationDate: Date | string
): string {
  if (typeof installationDate === 'string') {
    return dayjs(installationDate).toDate().toISOString().split('T')[0]
  } else {
    return installationDate.toISOString().split('T')[0]
  }
}

/**
 * Converts a string representation of a date to a Date object
 *
 * NOTE: the string passed in must be in the format YYYY-MM-DD
 * */
export function getInstallationDateFromString(
  jsonInstallationDateStr: string | undefined
): Date | undefined {
  if (
    typeof jsonInstallationDateStr === 'string' &&
    INSTALLATION_DATE_REGEX.test(jsonInstallationDateStr)
  ) {
    return dayjs(jsonInstallationDateStr).toDate()
  } else if (
    typeof jsonInstallationDateStr === 'string' &&
    jsonInstallationDateStr !== ''
  ) {
    console.warn(`Improperly formatted installation date on a GeckoEditableComponent.
        The installation_date field should be formatted YYYY-MM-DD, but got a value of ${jsonInstallationDateStr}`)
  }
  return undefined
}

export const INSTALLATION_DATE_REGEX = /^\d{4}-\d{2}-\d{2}$/
